import axios from 'axios';

export const fetchProjects = params => axios.get('/projects', { params });
export const fetchProject = id => axios.get(`/projects/${id}`);
export const fetchProjectFilters = (id, filterId) => axios.get(`/projects/${id}/filters/${filterId}`);
export const fetchProjectTranslations = id => axios.get(`/projects/${id}/translation`);
